import { render, staticRenderFns } from "./clip-img.vue?vue&type=template&id=6be4ef50&scoped=true"
import script from "./clip-img.vue?vue&type=script&lang=js"
export * from "./clip-img.vue?vue&type=script&lang=js"
import style0 from "./clip-img.vue?vue&type=style&index=0&id=6be4ef50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be4ef50",
  null
  
)

export default component.exports